import React, {Component, ReactElement, ReactNode} from 'react'
import {ResidentUserInfo} from '../roomToResident/repository/NatGetRoomToResident'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    DO_OR_NOT,
    MESSAGE_TYPE,
    RESIDENT_USER_REGISTRATION_APPLY_CATEGORY,
    ROLE_FOR_RESIDENT,
    SELECT_USER_TYPE,
} from '../../../CodeMaster'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import {autoKanaOnUpdate, getStringOrEmptyString, judgeAuthorityCheck} from '../../common/util/Natutil'
import PPRadioGroup from '../../../components/shared/forms/PPRadioGroup'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPErrorDisplayButton from '../../../components/shared/forms/PPErrorDisplayButton'
import styled from 'styled-components'
import NatResidentUserSelectionComponent from '../common/admin/NatResidentUserSelectionComponent'
import NatRidgeRepo from '../ridge/repository/NatRidgeRepo'
import {Messages} from '../../../Messages'
import {
    NatPutResidentUserRegistrationApplyRequest,
    NatPutResidentUserRegistrationApplyResponse,
} from '../roomToResident/repository/NatPutResidentUserRegistrationApply'
import {formatForDateInput} from '../../../formatters/formatDate'
import {StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import {NatGetRegistrationApplyResponse} from '../roomToResident/repository/NatGetRegistrationApply'
import {HKConstants} from '../../../HKConstants'
import PPErrorLabel from '../../../components/shared/forms/PPErrorLabel'
import NatRegistrationApplyMemoForm from './admin/NatRegistrationApplyMemoForm'
import {NatAdminCommonDialogComponent} from '../common/admin/NatAdminCommonDialogComponent'
import NatRegistrationApplyCardKeyNumberForm from './admin/NatRegistrationApplyCardKeyNumberForm'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {NatGetRidge, RidgeData} from '../ridge/repository/NatGetRidge'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'
import ReactDOM from 'react-dom'

const THIS_FUNCTION_NAME = '居住者ユーザ申請'


interface Props {
    applyId: number
    roomToResidentRepo: NatRoomToResidentRepo
    ridgeRepo: NatRidgeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY
    abolitionApplyFormFamilyName: string
    abolitionApplyFormFirstName: string
    abolitionExpectedDate: string
    registrationRoleId: ROLE_FOR_RESIDENT
    registrationStartDate: string
    registrationFamilyName: string
    registrationFirstName: string
    registrationFamilyNameKana: string
    registrationFirstNameKana: string
    sutekiNetId: string
    condominiumCd: string
    ridgeInfo: RidgeData[]
    ridgeCd: string
    ridgeName: string
    roomNumber: string
    abolitionSeq: Nullable<number>
    familyName: string
    firstName: string
    adminFamilyName: string
    adminFirstName: string
    memo: string
    version: number
    dialogOpenSelectResidentUser: boolean
    noticeApplyOpen: boolean
    isLoadCompleted: boolean
    clearErrorLabel: boolean
    allResidentStatus: boolean
    invalidUserSelectFlag: boolean
    cardKeyNumber: string
    cardKeyNumberDialogOpen: boolean
    cardKeyNumberRequired: string
    sameRoomDuplicateExclusionFlag: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

class NatAdminResidentUserApplyEditPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION,
            abolitionApplyFormFamilyName: '',
            abolitionApplyFormFirstName: '',
            abolitionExpectedDate: '',
            registrationRoleId: ROLE_FOR_RESIDENT.RESIDENT,
            registrationStartDate: '',
            registrationFamilyName: '',
            registrationFirstName: '',
            registrationFamilyNameKana: '',
            registrationFirstNameKana: '',
            sutekiNetId: '',
            condominiumCd: '',
            ridgeInfo: [],
            ridgeCd: '',
            ridgeName: '',
            roomNumber: '',
            abolitionSeq: null,
            familyName: '',
            firstName: '',
            adminFamilyName: '',
            adminFirstName: '',
            memo: '',
            version: 0,
            dialogOpenSelectResidentUser: false,
            noticeApplyOpen: false,
            isLoadCompleted: false,
            clearErrorLabel: false,
            allResidentStatus: false,
            invalidUserSelectFlag: false,
            cardKeyNumber: '',
            cardKeyNumberDialogOpen: false,
            cardKeyNumberRequired: DO_OR_NOT.NOT.value,
            sameRoomDuplicateExclusionFlag: false,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }

        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.handleRegistrationRidgeChange = this.handleRegistrationRidgeChange.bind(this)
        this.handleRegistrationRoomNumberChange = this.handleRegistrationRoomNumberChange.bind(this)
        this.handleAbolitionApplyFormFamilyNameChange = this.handleAbolitionApplyFormFamilyNameChange.bind(this)
        this.handleAbolitionApplyFormFirstNameChange = this.handleAbolitionApplyFormFirstNameChange.bind(this)
        this.handleAbolitionExpectedDateChange = this.handleAbolitionExpectedDateChange.bind(this)
        this.handleRegistrationRoleIdChange = this.handleRegistrationRoleIdChange.bind(this)
        this.handleRegistrationStartDateChange = this.handleRegistrationStartDateChange.bind(this)
        this.handleRegistrationFamilyNameChange = this.handleRegistrationFamilyNameChange.bind(this)
        this.handleRegistrationFirstNameChange = this.handleRegistrationFirstNameChange.bind(this)
        this.handleRegistrationFamilyNameKanaChange = this.handleRegistrationFamilyNameKanaChange.bind(this)
        this.handleRegistrationFirstNameKanaChange = this.handleRegistrationFirstNameKanaChange.bind(this)
        this.handleNoticeApplyCancelClick = this.handleNoticeApplyCancelClick.bind(this)
        this.handleNoticeApplyOkClick = this.handleNoticeApplyOkClick.bind(this)
        this.handleMemoChange = this.handleMemoChange.bind(this)
        this.judgeRegisterButtonDisabled = this.judgeRegisterButtonDisabled.bind(this)
        this.noticeApplyClick = this.noticeApplyClick.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.handleCancelClick = this.handleCancelClick.bind(this)
        this.handleCardKeyNumberChange = this.handleCardKeyNumberChange.bind(this)
        this.handleCardKeyNumberCancelClick = this.handleCardKeyNumberCancelClick.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getResidentUserRegistrationApply()
            const ridge: Nullable<NatGetRidge> = await this.props.asyncCallFunction(
                this.props.ridgeRepo.getRidgeList.bind(this.props.ridgeRepo, this.state.condominiumCd),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (ridge && ridge.details) {
                this.setState({ridgeInfo: ridge.details})
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async getResidentUserRegistrationApply(): Promise<void> {
        const {roomToResidentRepo, applyId} = this.props

        const residentUserApply: Nullable<NatGetRegistrationApplyResponse> = await this.props.asyncCallFunction(
            roomToResidentRepo.getResidentUserApply.bind(
                roomToResidentRepo,
                applyId,
            ),
            (httpErrorOrNetworkError) => {
                this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        if (residentUserApply && residentUserApply.details) {
            const applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY =
                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.codeToEnumConstants(
                    residentUserApply.details.applyCategory,
                )
            ReactDOM.flushSync(() => {
                this.setState({
                    applyCategory,
                    abolitionApplyFormFamilyName: residentUserApply.details.abolitionApplyFormFamilyName ?
                        residentUserApply.details.abolitionApplyFormFamilyName : '',
                    abolitionApplyFormFirstName: residentUserApply.details.abolitionApplyFormFirstName ?
                        residentUserApply.details.abolitionApplyFormFirstName : '',
                    abolitionExpectedDate: residentUserApply.details.abolitionExpectedDate ?
                        residentUserApply.details.abolitionExpectedDate : '',
                    registrationRoleId: residentUserApply.details.registrationRoleId ?
                        ROLE_FOR_RESIDENT.codeToEnumConstants(residentUserApply.details.registrationRoleId) :
                        ROLE_FOR_RESIDENT.RESIDENT,
                    registrationStartDate: residentUserApply.details.registrationStartDate ?
                        residentUserApply.details.registrationStartDate : '',
                    registrationFamilyName: residentUserApply.details.registrationFamilyName ?
                        residentUserApply.details.registrationFamilyName : '',
                    registrationFirstName: residentUserApply.details.registrationFirstName ?
                        residentUserApply.details.registrationFirstName : '',
                    registrationFamilyNameKana: residentUserApply.details.registrationFamilyNameKana ?
                        residentUserApply.details.registrationFamilyNameKana : '',
                    registrationFirstNameKana: residentUserApply.details.registrationFirstNameKana ?
                        residentUserApply.details.registrationFirstNameKana : '',
                    condominiumCd: residentUserApply.details.condominiumCd,
                    ridgeCd: residentUserApply.details.ridgeCd,
                    ridgeName: residentUserApply.details.ridgeName,
                    roomNumber: residentUserApply.details.roomNumber,
                    abolitionSeq: residentUserApply.details.abolitionSeq ?
                        residentUserApply.details.abolitionSeq : null,
                    familyName: residentUserApply.details.abolitionFamilyName ?
                        residentUserApply.details.abolitionFamilyName : '',
                    firstName: residentUserApply.details.abolitionFirstName ?
                        residentUserApply.details.abolitionFirstName : '',
                    adminFamilyName: residentUserApply.details.abolitionAdminFamilyName ?
                        residentUserApply.details.abolitionAdminFamilyName : '',
                    adminFirstName: residentUserApply.details.abolitionAdminFirstName ?
                        residentUserApply.details.abolitionAdminFirstName : '',
                    cardKeyNumberRequired: residentUserApply.details.cardKeyNumberRequired ?
                        residentUserApply.details.cardKeyNumberRequired : '',
                    version: residentUserApply.details.version,
                })
            })
            this.setResidentUserParameter(applyCategory)
        }
    }

    handleNoticeApplyCancelClick(): void {
        this.setState({noticeApplyOpen: false})
    }

    getMessageInheritToDetailPage(): string {
        if (judgeAuthorityCheck(HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER)) {
            return Messages.IRESA0023.toString(THIS_FUNCTION_NAME)
        } else {
            return Messages.IOPCC0008.toString(THIS_FUNCTION_NAME)
        }
    }

    async handleNoticeApplyOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            // 居住者ユーザ申請編集
            const putResidentUserRegistrationApplyParams: NatPutResidentUserRegistrationApplyRequest = {
                applyId: this.props.applyId,
                roomNumber: this.state.roomNumber,
                ridgeCd: this.state.ridgeCd,
                abolitionSeq: this.state.abolitionSeq,
                abolitionApplyFormFamilyName: this.state.abolitionApplyFormFamilyName,
                abolitionApplyFormFirstName: this.state.abolitionApplyFormFirstName,
                abolitionExpectedDate: this.state.abolitionExpectedDate,
                registrationRoleId: this.state.registrationRoleId.value,
                registrationFamilyName: this.state.registrationFamilyName,
                registrationFirstName: this.state.registrationFirstName,
                registrationFamilyNameKana: this.state.registrationFamilyNameKana,
                registrationFirstNameKana: this.state.registrationFirstNameKana,
                registrationStartDate: this.state.registrationStartDate,
                memo: this.state.memo,
                cardKeyNumber: this.state.cardKeyNumber,
                version: this.state.version,
            }

            const response: Nullable<NatPutResidentUserRegistrationApplyResponse> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.putResidentUserRegistrationApply.bind(
                    this.props.roomToResidentRepo, putResidentUserRegistrationApplyParams),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString(THIS_FUNCTION_NAME)},
            )

            if (response !== null && response.requestError === null) {
                this.setState({cardKeyNumber: '', cardKeyNumberDialogOpen: false})
                this.props.navigate(`/admin/residentUser/apply/${this.props.applyId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: this.getMessageInheritToDetailPage(),
                            },
                        },
                    },
                )
            }

        } finally {
            this.setState({noticeApplyOpen: false})
            this.props.eventEmitter.closeLoading()
        }
    }

    handleOpenResidentUserSelectionDialog(): void {
        this.setState({
            dialogOpenSelectResidentUser: true,
            clearErrorLabel: true,
        })
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    judgeRegisterButtonDisabled(): boolean {
        if (!(this.state.roomNumber && this.state.ridgeCd)) {
            return true
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION) {
            return !(this.state.abolitionSeq &&
                this.state.abolitionApplyFormFamilyName &&
                this.state.abolitionApplyFormFirstName &&
                this.state.abolitionExpectedDate)
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION) {
            return !(this.state.registrationRoleId &&
                this.state.registrationStartDate)
        } else if (this.state.applyCategory === RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) {
            return !(this.state.abolitionSeq &&
                this.state.abolitionApplyFormFamilyName &&
                this.state.abolitionApplyFormFirstName &&
                this.state.abolitionExpectedDate &&
                this.state.registrationRoleId &&
                this.state.registrationStartDate)
        } else {
            return true
        }
    }

    handleRegistrationRoleIdChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const registrationRoleId: ROLE_FOR_RESIDENT =
            ROLE_FOR_RESIDENT.codeToEnumConstants(`${event.target.value}`)
        this.setState({
            registrationRoleId,
            clearErrorLabel: true,
        })
    }

    handleRegistrationRidgeChange(event: SelectChangeEvent<unknown>): void {
        this.setState({ridgeCd: event.target.value as string})
    }

    handleRegistrationRoomNumberChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({roomNumber: event.target.value})
    }

    handleAbolitionApplyFormFamilyNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({abolitionApplyFormFamilyName: value})
    }

    handleAbolitionApplyFormFirstNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({abolitionApplyFormFirstName: value})
    }


    handleAbolitionExpectedDateChange(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({
                abolitionExpectedDate: formatForDateInput(date.toString()),
                clearErrorLabel: true,
            })
        } else {
            this.setState({
                abolitionExpectedDate: '',
                clearErrorLabel: true,
            })
        }
    }

    handleRegistrationStartDateChange(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({
                registrationStartDate: formatForDateInput(date.toString()),
                clearErrorLabel: true,
            })
        } else {
            this.setState({
                registrationStartDate: '',
                clearErrorLabel: true,
            })
        }
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.registrationFamilyNameKana ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.registrationFirstNameKana ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    handleRegistrationFamilyNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            registrationFamilyName: value,
            registrationFamilyNameKana: value ? this.state.convertFamilyNameKana : '',
            clearErrorLabel: true,
        })
    }

    handleRegistrationFirstNameChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            registrationFirstName: value,
            registrationFirstNameKana: value ? this.state.convertFirstNameKana : '',
            clearErrorLabel: true,
        })
    }

    handleRegistrationFamilyNameKanaChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            registrationFamilyNameKana: value,
            clearErrorLabel: true,
        })
    }

    handleRegistrationFirstNameKanaChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const value: string = event.target.value
        this.setState({
            registrationFirstNameKana: value,
            clearErrorLabel: true,
        })
    }

    handleMemoChange(value: string): void {
        this.setState({memo: value})
    }

    handleCardKeyNumberChange(value: string): void {
        this.setState({cardKeyNumber: value})
    }

    handleCardKeyNumberCancelClick(): void {
        this.setState({cardKeyNumber: '', cardKeyNumberDialogOpen: false})
    }

    convertRidgeIntoOptionProps(): OptionProps[] {
        const optionProps: OptionProps[] = this.state.ridgeInfo.map((ridge) => {
            return ({
                label: `${ridge.ridgeCd} : ${ridge.ridgeName}`,
                value: `${ridge.ridgeCd}`,
            })
        })
        return [{
            label: '棟を指定してください',
            value: '',
        }, ...optionProps]
    }

    renderInputFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>申請情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <TableCell colSpan={4}>
                                {this.state.applyCategory.label}
                                <PPErrorLabel
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['applyCategory']}
                                    clearError={this.state.clearErrorLabel}
                                />
                            </TableCell>
                        </TableRow>
                        {this.state.applyCategory !== null &&
                            (this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) &&
                            <TableRow>
                                <TableRowName required>居住者ユーザを選択</TableRowName>
                                <TableCell colSpan={4}>
                                    <RowFlexContainer>
                                        <SelectedFlexWrapper>
                                            <PPErrorDisplayButton
                                                component={'span'}
                                                size={'small'}
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['sutekiNetId', 'ridgeCd', 'roomNumber', 'abolitionSeq']}
                                                onClick={this.handleOpenResidentUserSelectionDialog}
                                                clearError={true}
                                            >
                                                選択する
                                            </PPErrorDisplayButton>
                                        </SelectedFlexWrapper>
                                        {this.renderSelectedResidentUserInfo()}
                                    </RowFlexContainer>
                                </TableCell>
                            </TableRow>
                        }
                        {this.state.dialogOpenSelectResidentUser &&
                            <NatResidentUserSelectionComponent
                                roomToResidentRepo={this.props.roomToResidentRepo}
                                ridgeRepo={this.props.ridgeRepo}
                                selectUserType={SELECT_USER_TYPE.USER.value}
                                closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                                setSelectedResidentUserInfo={this.setSelectedResidentUserInfo}
                                selectedCondominiumCd={this.state.condominiumCd}
                                allResidentStatus={this.state.allResidentStatus}
                                invalidUserSelectFlag={this.state.invalidUserSelectFlag}
                                sameRoomDuplicateExclusionFlag={this.state.sameRoomDuplicateExclusionFlag}
                                mainUserFlag={true}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {(this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) &&
                            <>
                                <TableRow>
                                    <TableRowName required>廃止申請書 氏名</TableRowName>
                                    <TableCell colSpan={2}>
                                        姓
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    name: 'abolitionApplyFormFamilyName',
                                                    id: 'abolitionApplyFormFamilyName',
                                                    maxLength: 10,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            value={this.state.abolitionApplyFormFamilyName}
                                            onInput={this.handleAbolitionApplyFormFamilyNameChange}
                                            onChange={this.handleAbolitionApplyFormFamilyNameChange}
                                            eventKeys={['abolitionApplyFormFamilyName']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={2}>
                                        名
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    name: 'abolitionApplyFormFirstName',
                                                    id: 'abolitionApplyFormFirstName',
                                                    maxLength: 10,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            value={this.state.abolitionApplyFormFirstName}
                                            onInput={this.handleAbolitionApplyFormFirstNameChange}
                                            onChange={this.handleAbolitionApplyFormFirstNameChange}
                                            eventKeys={['abolitionApplyFormFirstName']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableRowName required>廃止予定日</TableRowName>
                                    <TableCell colSpan={2}>
                                        <PPDatePicker
                                            value={(this.state.abolitionExpectedDate !== '') ?
                                                new Date(this.state.abolitionExpectedDate) : null
                                            }
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['abolitionExpectedDate']}
                                            onChangeDate={this.handleAbolitionExpectedDateChange}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>
                                </TableRow>
                            </>
                        }
                        {(this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION ||
                                this.state.applyCategory ===
                                RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION) &&
                            <>
                                <TableRow>
                                    <TableRowName required>新規登録居住者ユーザ 権限</TableRowName>
                                    <TableCell colSpan={4}>
                                        <PPRadioGroup
                                            row
                                            data={ROLE_FOR_RESIDENT.values()}
                                            onChange={this.handleRegistrationRoleIdChange}
                                            value={this.state.registrationRoleId.value}
                                            eventKeys={['registrationRoleId']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                </TableRow>
                                {this.state.applyCategory ===
                                    RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION &&
                                    <>
                                        <TableRow>
                                            <TableRowName required>新規登録居住者ユーザ 棟名</TableRowName>
                                            <TableCell colSpan={2}>
                                                <PPSelect
                                                    required
                                                    fullWidth
                                                    data={this.convertRidgeIntoOptionProps()}
                                                    onChange={this.handleRegistrationRidgeChange}
                                                    value={this.state.ridgeCd}
                                                    eventKeys={['ridgeCd']}
                                                    eventEmitter={this.props.eventEmitter}

                                        />
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableRowName required>新規登録居住者ユーザ 部屋番号</TableRowName>
                                    <TableCell colSpan={2}>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    maxLength: 4,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            onChange={this.handleRegistrationRoomNumberChange}
                                            value={this.state.roomNumber}
                                            eventKeys={['roomNumber']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                    <TableCell colSpan={2}></TableCell>
                                </TableRow>
                            </>
                            }
                            <TableRow>
                                <TableRowName>新規登録居住者ユーザ 氏名</TableRowName>
                                <TableCell colSpan={2}>
                                    姓
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFamilyName',
                                                id: 'registrationFamilyName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFamilyName}
                                        onInput={this.handleRegistrationFamilyNameChange}
                                        onChange={this.handleRegistrationFamilyNameChange}
                                        onCompositionStart={this.onCompositionStartFamilyName}
                                        onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                        eventKeys={['registrationFamilyName']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    名
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFirstName',
                                                id: 'registrationFirstName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFirstName}
                                        onInput={this.handleRegistrationFirstNameChange}
                                        onChange={this.handleRegistrationFirstNameChange}
                                        onCompositionStart={this.onCompositionStartFirstName}
                                        onCompositionUpdate={this.onCompositionUpdateFirstName}
                                        eventKeys={['registrationFirstName']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>新規登録居住者ユーザ 氏名(フリガナ)</TableRowName>
                                <TableCell colSpan={2}>
                                    セイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFamilyNameKana',
                                                id: 'registrationFamilyNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFamilyNameKana}
                                        onInput={this.handleRegistrationFamilyNameKanaChange}
                                        onChange={this.handleRegistrationFamilyNameKanaChange}
                                        eventKeys={['registrationFamilyNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    メイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'registrationFirstNameKana',
                                                id: 'registrationFirstNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registrationFirstNameKana}
                                        onInput={this.handleRegistrationFirstNameKanaChange}
                                        onChange={this.handleRegistrationFirstNameKanaChange}
                                        eventKeys={['registrationFirstNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>利用開始日</TableRowName>
                                <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 22}}>
                                    <PPDatePicker
                                        value={(this.state.registrationStartDate !== '') ?
                                            new Date(this.state.registrationStartDate) : null
                                        }
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['registrationStartDate']}
                                        onChangeDate={this.handleRegistrationStartDateChange}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}></TableCell>
                            </TableRow>
                        </>
                        }
                    </TableBody>
                </Table>
            </>
        )
    }

    setSelectedResidentUserInfo(selectedResidentUserInfo: ResidentUserInfo): void {
        this.setState({
            sutekiNetId: selectedResidentUserInfo.sutekiNetId,
            ridgeCd: selectedResidentUserInfo.ridgeCd,
            ridgeName: selectedResidentUserInfo.ridgeName,
            roomNumber: selectedResidentUserInfo.roomNumber,
            abolitionSeq: selectedResidentUserInfo.seq,
            familyName: selectedResidentUserInfo.familyName ? selectedResidentUserInfo.familyName : '',
            firstName: selectedResidentUserInfo.firstName ? selectedResidentUserInfo.firstName : '',
            adminFamilyName: selectedResidentUserInfo.adminFamilyName ? selectedResidentUserInfo.adminFamilyName : '',
            adminFirstName: selectedResidentUserInfo.adminFirstName ? selectedResidentUserInfo.adminFirstName : '',
            dialogOpenSelectResidentUser: false,
        })
    }


    renderSelectedResidentUserInfo(): ReactNode {
        return (
            <>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>部屋番号</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValue>
                        {this.state.ridgeName} {this.state.roomNumber}
                    </SelectedModalInfoItemValue>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueForUserName>
                        {this.getDisplayName(this.state.familyName, this.state.firstName)}
                    </SelectedModalInfoItemValueForUserName>
                </SelectedFlexWrapperWide>
                <SelectedFlexWrapperWide>
                    <SelectedModalInfoItemLabel>管理者確認用氏名</SelectedModalInfoItemLabel>
                    <SelectedModalInfoItemValueForUserName>
                        {this.getDisplayName(this.state.adminFamilyName, this.state.adminFirstName)}
                    </SelectedModalInfoItemValueForUserName>
                </SelectedFlexWrapperWide>
            </>
        )
    }

    getDisplayName(familyName: Nullable<string>, firstName: Nullable<string>): string {
        if (familyName || firstName) {
            return (`${getStringOrEmptyString(familyName)} ${getStringOrEmptyString(firstName)}`)
        } else {
            return ''
        }
    }

    handleCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    // 登録ボタン押下
    async noticeApplyClick(): Promise<void> {
        this.beforeUserAction()
        this.setState({clearErrorLabel: false})
        if (judgeAuthorityCheck(HKConstants.CMN.AUTH.APPROVAL_RESIDENT_USER)) {
            if (this.state.cardKeyNumberRequired === DO_OR_NOT.DO.value) {
                this.setState({cardKeyNumberDialogOpen: true})
            } else {
                await this.props.eventEmitter.showDialog({
                        title: '確認',
                        errorLevel: Messages.IRESA0022.errorLevel,
                        message: Messages.IRESA0022.toString('編集・承認'),
                        buttonProps: [
                            {
                                isDefault: false,
                                buttonLabel: 'キャンセル',
                                buttonHandler: this.handleCancelClick,
                            },
                            {
                                isDefault: false,
                                buttonLabel: 'OK',
                                buttonHandler: this.handleNoticeApplyOkClick,
                            },
                        ],
                    },
                )
            }
        } else {
            this.setState({noticeApplyOpen: true})
        }
    }

    setResidentUserParameter(applyCategory: RESIDENT_USER_REGISTRATION_APPLY_CATEGORY): void {
        switch (applyCategory) {
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION:
                ReactDOM.flushSync(() => {
                    this.setState({
                        allResidentStatus: false,
                        invalidUserSelectFlag: true,
                        sameRoomDuplicateExclusionFlag: false,
                    })
                })
                break
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.REGISTRATION:
                ReactDOM.flushSync(() => {
                    this.setState({
                        allResidentStatus: true,
                        invalidUserSelectFlag: false,
                        sameRoomDuplicateExclusionFlag: true,
                    })
                })
                break
            case RESIDENT_USER_REGISTRATION_APPLY_CATEGORY.ABOLITION_REGISTRATION:
                ReactDOM.flushSync(() => {
                    this.setState({
                        allResidentStatus: false,
                        invalidUserSelectFlag: true,
                        sameRoomDuplicateExclusionFlag: false,
                    })
                })
                break
        }
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgeRegisterButtonDisabled()}
                        onClick={this.noticeApplyClick}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        to={'/admin/residentUser/applyList'}
                    >
                        居住者ユーザ申請一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted
        ) {
            return null
        }
        const memoForm = (<NatRegistrationApplyMemoForm
            memo={this.state.memo}
            eventEmitter={this.props.eventEmitter}
            onChange={this.handleMemoChange}
        />)
        const cardKeyForm = (<NatRegistrationApplyCardKeyNumberForm
            cardKeyNumber={this.state.cardKeyNumber}
            eventEmitter={this.props.eventEmitter}
            onChange={this.handleCardKeyNumberChange}
        />)
        return (
            <>
                <NatAdminCommonDialogComponent
                    params={{
                        title: '確認',
                        errorLevel: Messages.IRESA0029.errorLevel,
                        message: Messages.IRESA0029.toString('編集・承認'),
                        buttonProps: [
                            {
                                isDefault: false,
                                buttonLabel: 'キャンセル',
                                buttonHandler: this.handleCardKeyNumberCancelClick,
                                buttonDisabled: false,
                            },
                            {
                                isDefault: false,
                                buttonLabel: 'OK',
                                buttonHandler: this.handleNoticeApplyOkClick,
                                buttonDisabled: !this.state.cardKeyNumber,
                            },
                        ],
                    }}
                    inputAreaComponent={cardKeyForm}
                    open={this.state.cardKeyNumberDialogOpen}/>
                <NatAdminCommonDialogComponent
                    params={{
                        title: '確認',
                        errorLevel: Messages.IRESA0030.errorLevel,
                        message: Messages.IRESA0030.toString(),
                        buttonProps: [
                            {
                                isDefault: false,
                                buttonLabel: 'キャンセル',
                                buttonHandler: this.handleNoticeApplyCancelClick,
                                buttonDisabled: false,
                            },
                            {
                                isDefault: false,
                                buttonLabel: 'OK',
                                buttonHandler: this.handleNoticeApplyOkClick,
                                buttonDisabled: false,
                            },
                        ],
                    }}
                    inputAreaComponent={memoForm}
                    open={this.state.noticeApplyOpen}/>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )

    }
}

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: center;
`

const SelectedFlexWrapperWide = styled(SelectedFlexWrapper)`
  flex-grow: 2;
`

export const SelectedModalInfoItemLabel: StyledSpan = styled.span`
  font-size: smaller;
  white-space: nowrap;
  margin-left: 20px;
  margin-right: 20px;
`

export const SelectedModalInfoItemValue: StyledSpan = styled.span`
  font-weight: bolder;
  white-space: normal;
  margin-right: 20px;
`

export const SelectedModalInfoItemValueForUserName = styled(SelectedModalInfoItemValue)`
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
`

export default createAdminPage(NatAdminResidentUserApplyEditPage)
